export default __webpack_public_path__ + "static/media/black-n-background.d70ce3fc.svg";